import { ConfirmationLineTable } from "./ConfirmationLineTable";
import type { ConfirmationCategoryTableProps, ConfirmationTableColumn } from "./tableTypes";
import { col, dateText, subtotal } from "./tableColumns";
import { confirmationGroupKey, confirmationHotelKey, confirmationLineDisplayName } from "../../../service/confirmationEditorView";
import type { FulfillmentOrderLine } from "../../../types";

/** 独立维护住宿范围、酒店及房型的表格展示。 */
export function ConfirmationStayTable({ common, table }: ConfirmationCategoryTableProps) {
  const { item, provider, quantity, count, price, amount, tail } = common;
  const groupKey = (line: FulfillmentOrderLine) => confirmationGroupKey(line, "stay");
  const columns: ConfirmationTableColumn[] = [
    col("range", "住宿范围", 102, (line) => <strong>{line.dayExpression || dateText(line)}</strong>, false, groupKey),
    { ...provider, width: 190, label: "服务酒店 SPU", render: line => confirmationLineDisplayName(line), merge: (line) => JSON.stringify([groupKey(line), confirmationHotelKey(line)]) },
    { ...item, width: 205, label: "房型", render: (line) => {
      const title = line.skuNameSnapshot || line.itemSpecSnapshot || "房型待补充";
      const source = line.skuId?.trim() && line.skuTableName === "resource_stay_fulfill_sku" ? "酒店房型" : "房型来源未知";
      return <>{common.itemTitle(line, title)}<small className="confirmation-item-detail"><span>{source}{line.itemSpecSnapshot && line.itemSpecSnapshot !== title ? ` · ${line.itemSpecSnapshot}` : ""}</span><span className="confirmation-line-number">#{line.lineNo}</span></small></>;
    } },
    quantity("间数"), count("晚数"),
    price, amount, subtotal("范围小计 / 差异", groupKey), ...tail,
  ];
  return <ConfirmationLineTable {...table} columns={columns} variant="stay" />;
}
